import React, { Component } from "react"

export class RedirectAdmin extends Component {
    componentWillMount() {
        window.location.replace(process.env.REACT_APP_ADMIN_URL)
    }

    render() {
        return (<section>Redirecting...</section>)
    }
}

export default RedirectAdmin



// WEBPACK FOOTER //
// ./src/components/redirect.js